import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';

import { ApplicationService } from '@state/application';
import { environment } from '@env/environment';
import { Investment, InvestmentService } from '@state/investment';
import { setWindowLocation } from '@helpers/url';

@Injectable({
  providedIn: 'root'
})
export class InvestmentResolver {
  private applicationService = inject(ApplicationService);
  private investmentService = inject(InvestmentService);
  private router = inject(Router);

  resolve(route: ActivatedRouteSnapshot): Observable<Investment> {
    let investmentId: string = route.params.investment_id;
    let providerEntityId: string = route.params.provider_entity_id;
    this.applicationService.pushLoading('investment');

    return this.investmentService.getAndStoreInvestment$(investmentId, providerEntityId).pipe(
      switchMap(
        (investment) =>
          new Observable<Investment>(() => {
            let { vehicle, id } = investment;
            let { fliUrl } = environment;
            let orgUrlSlug = vehicle.organization_url_slug;

            if (orgUrlSlug) {
              setWindowLocation(`${fliUrl}/g/${orgUrlSlug}/investments/${id}`);
            } else {
              // Need to create a NOT NULL constraint at the DB level,
              // until we do we need to route to FLI root
              setWindowLocation(fliUrl);
            }
          })
      ),
      catchError((error: HttpErrorResponse) => {
        console.error(error);
        void this.router.navigate(['/404'], { skipLocationChange: true });
        return EMPTY;
      }),
      finalize(() => this.applicationService.popLoading('investment'))
    );
  }
}
